import React from "react";
import { Link } from "react-router-dom";
import { Grid } from "@mui/material";
import styles from "./style.module.scss";
import Card from "../Commons/Card";

const DashboardContainer = () => {
  return (
    <Grid container spacing={3} className={styles.container}>
      <Grid item xs={12} sm={12} md={4} lg={4}>
        <Link to="/assessments" style={{ textDecoration: "none" }}>
          <Card btnText={"view more"} cardTitle={"assessments"} btn />
        </Link>
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={4}>
        <Link to="/studenttraining" style={{ textDecoration: "none" }}>
          <Card btnText={"view more"} cardTitle={"training modules"} btn />
        </Link>
      </Grid>

      {/* <Grid item xs={12} sm={6} md={4} lg={4}>
        <Card btnText={"view more"} cardTitle={"progress"} btn />
      </Grid> */}
    </Grid>
  );
};

export default DashboardContainer;
